/**
 * Default middleware handle access to route and offline page
 */
export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) {
    if (
      to.meta.auth &&
      to.meta.auth !== useAuthStatus.UNKNOWN &&
      to.name !== "authentification-callback-client-apple" &&
      to.name !== "authentification-callback-facebook" &&
      to.name !== "authentification-callback-google"
    ) {
      const redirect = useCookie("redirect");
      redirect.value = to.fullPath;
      return navigateTo("/authentification/chargement");
    }
  } else {
    const route = useRouteValidation(to);

    if (route) {
      return navigateTo(route);
    }
  }
});
